import { AlphaHBoxIcon } from './AlphaHBoxIcon';

/**
 * author: GreenTurtwig
 * id 180E5F6A-8C7E-4B29-92C1-94C97D1266B9
 * name alpha-h-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-h-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetHBoxIcon = AlphaHBoxIcon;
export default AlphabetHBoxIcon